module.exports = __webpack_public_path__ + "img/N347-2.dbc117f3.png";